import React, { type ReactNode } from 'react';
import styles from '../styles.module.css';
import classNames from 'classnames';

const ToolbarColumn: React.FC<{ children: ReactNode }> = ({ children }) => {
  return <div className={classNames(styles.toolbarColumn)}>{children}</div>;
};

export default ToolbarColumn;
